export default{
    section:'بخش',
    impressionLocationsTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    impressionLocations:'Impression Locations',
    editImpressionLocations:'ویرایش Impression Locations',
    addImpressionLocations:'Impression Locations جدید',
}